import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { useEffect } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog';
import { useAuth } from '@/hooks/useAuth';
import { toast } from 'sonner';

interface DeletePixelModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isFlow?: boolean;
}

export function DeletePixelModal({ open, onOpenChange, onConfirm, isFlow = false }: DeletePixelModalProps) {
  useLanguage();
  const { hasPermission } = useAuth();
  const canEdit = hasPermission('pixel', 'edit');

  useEffect(() => {
    if (open && !canEdit) {
      toast.error(translateInterfaceText("Sem permissão para remover pixels"));
      onOpenChange(false);
    }
  }, [open, canEdit, onOpenChange]);

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="!w-[40vh] md:w-[35vh] rounded-xl p-6">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-semibold text-foreground">
            {translateInterfaceText("Remover pixel?")}</AlertDialogTitle>
          <AlertDialogDescription className="text-sm text-muted-foreground mt-1.5">
            {isFlow ? translateInterfaceText("Isso interrompe o rastreamento deste pixel em todos os vídeos do funil.") : translateInterfaceText("Isso interrompe o rastreamento deste vídeo.")} {" "}{translateInterfaceText("Esta ação não pode ser desfeita.")}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-4 flex justify-end gap-2">
          <AlertDialogCancel className="h-10 px-4 rounded-[10px] border-border text-muted-foreground hover:bg-muted hover:text-[#1E293B] transition-colors">
            {translateInterfaceText("Cancelar")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="h-10 px-4 rounded-[10px] bg-red-600 hover:bg-red-700 text-white font-semibold transition-colors"
          >
            {translateInterfaceText("Remover")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
